<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/inspection/standard/details/page" getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1'); getInspectionList()" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="show = !show" plain>
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #chouyangguocheng="scope">
        <span v-if="scope.row.samplingProcedure">{{ scope.row.samplingProcedure.code }}/{{ scope.row.samplingProcedure.desc }}</span>
      </template>
      <!--检验标识-->
      <template #jianyanbiaoshi="scope">
        <span v-if="scope.row.flag === 1">{{ $t('dingxing') }}</span>
        <span v-if="scope.row.flag === 2">{{ $t('dingliang') }}</span>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row); getInspectionList()">{{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/quality/inspection/standard/details/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('gongxu')" required>
              <el-input v-model="yt.editObj.procedure"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanleibie')" required>
              <el-input v-model="yt.editObj.category"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanxiangmu')" required>
              <el-input v-model="yt.editObj.item"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyangongju')" required>
              <el-input v-model="yt.editObj.tool"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanbiaoshi')" required>
              <el-select v-model="yt.editObj.flag" clearable>
                <el-option :label="$t('dingxing')" :value="1"></el-option>
                <el-option :label="$t('dingliang')" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('jianyanfangshi')" required>
              <el-select :max="1" filterable :clearable="true" v-model="yt.editObj.inspectionMethodId">
                <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifoubijian')" required>
              <el-select v-model="yt.editObj.necessity" clearable>
                <el-option :label="$t('shi')" :value="1"></el-option>
                <el-option :label="$t('fou')" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('jianyanyiju')">
              <el-input v-model="yt.editObj.basis"></el-input>
            </el-form-item>
            <el-form-item :label="$t('quexiandengji')">
              <el-input v-model="yt.editObj.defectLevel"></el-input>
            </el-form-item>
            <div v-if="yt.editObj.flag === 1">
              <el-form-item :label="$t('chouyangguocheng')" required>
                <yi_cross_select :max="1" :selectTitle="'code,desc'" :component="'web_quality_management_sampling_procedure_list'" :ids.sync="yt.editObj.samplingProcedureId">
                </yi_cross_select>
              </el-form-item>
              <el-form-item :label="$t('guigexiaxian')">
                <el-input v-model="yt.editObj.specMin"></el-input>
              </el-form-item>
              <el-form-item :label="$t('guigeshangxian')">
                <el-input v-model="yt.editObj.specMax"></el-input>
              </el-form-item>
              <el-form-item :label="$t('jiliangdanwei')">
                <el-input v-model="yt.editObj.unit"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.flag === 2">
              <el-form-item :label="$t('chouyangguocheng')" required>
                <yi_cross_select :max="1" :selectTitle="'code,desc'" :component="'web_quality_management_sampling_procedure_list'" :ids.sync="yt.editObj.samplingProcedureId">
                </yi_cross_select>
              </el-form-item>
              <el-form-item :label="$t('guigexiaxian')" required>
                <el-input v-model="yt.editObj.specMin"></el-input>
              </el-form-item>
              <el-form-item :label="$t('guigeshangxian')" required>
                <el-input v-model="yt.editObj.specMax"></el-input>
              </el-form-item>
              <el-form-item :label="$t('jiliangdanwei')" required>
                <el-input v-model="yt.editObj.unit"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/quality/inspection/standard/details/create', beforeAdd)" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '物料检验标准-新增物料检验标准明细' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('gongxu')" required>
              <el-input v-model="yt.editObj.procedure"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanleibie')" required>
              <el-input v-model="yt.editObj.category"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanxiangmu')" required>
              <el-input v-model="yt.editObj.item"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyangongju')" required>
              <el-input v-model="yt.editObj.tool"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanbiaoshi')" required>
              <el-select v-model="yt.editObj.flag" clearable>
                <el-option :label="$t('dingxing')" :value="1"></el-option>
                <el-option :label="$t('dingliang')" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('jianyanfangshi')" required>
              <el-select :max="1" filterable :clearable="true" v-model="yt.editObj.inspectionMethodId">
                <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('shifoubijian')" required>
              <el-select v-model="yt.editObj.necessity" clearable>
                <el-option :label="$t('shi')" :value="1"></el-option>
                <el-option :label="$t('fou')" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('jianyanyiju')">
              <el-input v-model="yt.editObj.basis"></el-input>
            </el-form-item>
            <el-form-item :label="$t('quexiandengji')">
              <el-input v-model="yt.editObj.defectLevel"></el-input>
            </el-form-item>
            <div v-if="yt.editObj.flag === 1">
              <el-form-item :label="$t('chouyangguocheng')" required>
                <yi_cross_select :max="1" :selectTitle="'code,desc'" :component="'web_quality_management_sampling_procedure_list'" :ids.sync="yt.editObj.samplingProcedureId">
                </yi_cross_select>
              </el-form-item>
              <el-form-item :label="$t('guigexiaxian')">
                <el-input v-model="yt.editObj.specMin"></el-input>
              </el-form-item>
              <el-form-item :label="$t('guigeshangxian')">
                <el-input v-model="yt.editObj.specMax"></el-input>
              </el-form-item>
              <el-form-item :label="$t('jiliangdanwei')">
                <el-input v-model="yt.editObj.unit"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.flag === 2">
              <el-form-item :label="$t('chouyangguocheng')" required>
                <yi_cross_select :max="1" :selectTitle="'code,desc'" :component="'web_quality_management_sampling_procedure_list'" :ids.sync="yt.editObj.samplingProcedureId">
                </yi_cross_select>
              </el-form-item>
              <el-form-item :label="$t('guigexiaxian')" required>
                <el-input v-model="yt.editObj.specMin"></el-input>
              </el-form-item>
              <el-form-item :label="$t('guigeshangxian')" required>
                <el-input v-model="yt.editObj.specMax"></el-input>
              </el-form-item>
              <el-form-item :label="$t('jiliangdanwei')" required>
                <el-input v-model="yt.editObj.unit"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/quality/inspection/standard/details/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" :inspectionStandardId="$attrs.details.id" />
  </div>
</template>
<script type="text/javascript">
import importExcel from './import_excel'

export default {
  name: 'web_quality_management_inspection_standard_details_item',
  components: {
    importExcel
  },
  data() {
    return {
      show: false,
      typeList: [],
      columns: [{
        label: 'gongxu',
        prop: 'procedure',
      }, {
        label: 'jianyanleibie',
        prop: 'category',
        width: 130,
      }, {
        label: 'jianyanxiangmu',
        prop: 'item',
        width: 180,
      }, {
        label: 'jianyangongju',
        prop: 'tool',
        width: 130,
        // format: 'yyyy-MM-dd:hh:mm:ss'
      },
      {
        label: 'jianyanbiaoshi',
        // prop: 'flag',
        type: 'slot',
        width: 100,
      },
      {
        label: 'jianyanfangshi',
        prop: 'inspectionMethod.name',
        width: 180,
      },
      {
        label: 'shifoubijian',
        prop: 'necessity',
        type: 'bool',
        iln18: ['shi', 'fou'],
      },
      {
        label: 'jianyanyiju',
        prop: 'basis',
        width: 180,
      },
      {
        label: 'quexiandengji',
        prop: 'defectLevel',
        width: 180,
      },
      {
        label: 'chouyangguocheng',
        type: 'slot',
        width: 180,
      },
      {
        label: 'guigexiaxian',
        prop: 'specMin',
        width: 180,
      }, {
        label: 'guigeshangxian',
        prop: 'specMax',
        width: 180,
      }, {
        label: 'jiliangdanwei',
        prop: 'unit',
        width: 180,
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 150,
        fixed: 'right'
      }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        inspectionStandardId: this.$attrs.details.id,
      }
      this.yt.get(1);
      this.utils.event_hub.$on('DETAILS_ITEM_REFRESH', () => {
        this.yt.get(1);
      })
    }, 300)
  },

  methods: {
    async getInspectionList() {
      this.showTab = false
      return await this.http.get('/web/quality/inspection/method/list?' + this.qs.stringify({
        // pageNum: 1,
        // pageSize: 100,
        inspectionType: this.$attrs.details.type
        // orderBy: 'sort',
      })).then(response => {
        this.typeList = response.data || []
      }).catch(() => {

      })
    },
    beforeAdd(params, url) {
      params.inspectionStandardId = this.$attrs.details.id
      return params
    }
  }
};
</script>
